import Vue from 'vue'
import Router from 'vue-router'
import Home from './components/Home'
import Login from './components/auth/Login' 
import Layout from './components/Layout'
import NotFound from './components/NotFound'
import Blagajna from './components/Blagajna'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },

    {
      path: '/',
      component: Layout,
      children: [
        {
          path: 'domov',
          alias: '',
          component: Home,
          name: 'home',
          meta: { requiresAuth: true }
        },
        {
          path: 'blagajne',
          name: 'blagajne',
          component: Blagajna
        },
        {
          path: '*',
          name: '404',
          component: NotFound
        }
      ]

    }    
  ]
})
